// import "./ConfirmModal.css";

// // Generic Yes/No confirmation popup. Fully controlled — the parent owns the
// // open/closed state and decides what "Yes" actually does.
// //
// // Usage:
// //   <ConfirmModal
// //       open={showConfirm}
// //       title="Publish this MOM?"
// //       message="Once published, this meeting can no longer be edited."
// //       confirmLabel="Yes, Publish"
// //       cancelLabel="Cancel"
// //       onConfirm={() => { setShowConfirm(false); doTheThing(); }}
// //       onCancel={() => setShowConfirm(false)}
// //   />
// function ConfirmModal({
//     open,
//     title = "Are you sure?",
//     message,
//     confirmLabel = "Yes, Publish",
//     cancelLabel = "Cancel",
//     onConfirm,
//     onCancel,
//     busy = false,
// }) {
//     if (!open) return null;

//     return (
//         <div className="confirm-modal-overlay" onClick={onCancel}>
//             <div
//                 className="confirm-modal-card"
//                 role="dialog"
//                 aria-modal="true"
//                 onClick={(e) => e.stopPropagation()}
//             >
//                 <h4 className="confirm-modal-title">{title}</h4>
//                 {message && <p className="confirm-modal-message">{message}</p>}
//                 <div className="confirm-modal-actions">
//                     <button
//                         className="confirm-modal-btn confirm-modal-btn-no"
//                         onClick={onCancel}
//                         disabled={busy}
//                     >
//                         {cancelLabel}
//                     </button>
//                     <button
//                         className="confirm-modal-btn confirm-modal-btn-yes"
//                         onClick={onConfirm}
//                         disabled={busy}
//                     >
//                         {busy ? "Please wait..." : confirmLabel}
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default ConfirmModal;


import "./ConfirmModal.css";

// Generic Yes/No confirmation popup. Fully controlled — the parent owns the
// open/closed state and decides what "Yes" actually does.
//
// Usage:
//   <ConfirmModal
//       open={showConfirm}
//       title="Publish this MOM?"
//       message="Once published, this meeting can no longer be edited."
//       confirmLabel="Yes, Publish"
//       cancelLabel="Cancel"
//       onConfirm={() => { setShowConfirm(false); doTheThing(); }}
//       onCancel={() => setShowConfirm(false)}
//       busy={false}
//   />
function ConfirmModal({
    open,
    title = "Are you sure?",
    message,
    confirmLabel = "Yes, Publish",
    cancelLabel = "Cancel",
    onConfirm,
    onCancel,
    busy = false,
}) {
    if (!open) return null;

    // Handle Escape key to close modal
    const handleKeyDown = (e) => {
        if (e.key === "Escape" && !busy) {
            onCancel?.();
        }
    };

    return (
        <div
            className="confirm-modal-overlay"
            onClick={onCancel}
            onKeyDown={handleKeyDown}
            role="presentation"
        >
            <div
                className="confirm-modal-card"
                role="dialog"
                aria-modal="true"
                aria-labelledby="confirm-modal-title"
                aria-describedby="confirm-modal-message"
                onClick={(e) => e.stopPropagation()}
            >
                <h4
                    id="confirm-modal-title"
                    className="confirm-modal-title"
                >
                    {title}
                </h4>
                {message && (
                    <p
                        id="confirm-modal-message"
                        className="confirm-modal-message"
                    >
                        {message}
                    </p>
                )}
                <div className="confirm-modal-actions">
                    <button
                        className="confirm-modal-btn confirm-modal-btn-no"
                        onClick={onCancel}
                        disabled={busy}
                        type="button"
                    >
                        {cancelLabel}
                    </button>
                    <button
                        className="confirm-modal-btn confirm-modal-btn-yes"
                        onClick={onConfirm}
                        disabled={busy}
                        type="button"
                    >
                        {busy ? "Please wait..." : confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmModal;